import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <section className="page-section legal-page">
      <div className="shell legal-shell">
        <header className="legal-hero">
          <span className="eyebrow">Son güncelleme: 13 Temmuz 2026</span>
          <h1>Kullanım Koşulları</h1>
          <p>
            Tripzy’yi kullanarak bu koşulları ve bağlantılı Gizlilik
            Politikası’nı kabul etmiş olursunuz.
          </p>
          <div className="legal-notice">
            Bu taslak ürünün mevcut özelliklerine göre hazırlanmıştır ve canlı
            yayın öncesinde ayrıca hukuki kontrolden geçirilmelidir.
          </div>
        </header>

        <article className="legal-content standalone-legal">
          <section>
            <h2>1. Hizmetin kapsamı</h2>
            <p>
              Tripzy; yer keşfi, yapay zekâ destekli gezi planlama, rota
              oluşturma, navigasyona yardımcı bilgiler, kayıtlı yerler ve gezi
              ilerlemesi gibi özellikler sunar. Bazı özellikler internet,
              konum izni veya premium abonelik gerektirebilir.
            </p>
          </section>

          <section>
            <h2>2. Hesap kullanımı ve güvenliği</h2>
            <ul>
              <li>Kayıt bilgileriniz doğru ve güncel olmalıdır.</li>
              <li>Giriş kodu, parola ve cihaz erişiminizin güvenliğinden siz sorumlusunuz.</li>
              <li>Başkasının hesabını kullanamaz veya hesabınızı kötüye kullanım için paylaşamazsınız.</li>
              <li>Şüpheli erişimi fark ettiğinizde destek ekibine bildirmelisiniz.</li>
            </ul>
          </section>

          <section>
            <h2>3. Kullanıcı yorumları ve içerikleri</h2>
            <p>
              Gönderdiğiniz yorum ve geri bildirimlerin hukuka uygun, yanıltıcı
              olmayan ve üçüncü taraf haklarını ihlal etmeyen içerikler olması
              gerekir. Hakaret, spam, kişisel bilgi ifşası, yasa dışı içerik ve
              manipülatif değerlendirmeler kaldırılabilir; ilgili hesap
              kısıtlanabilir.
            </p>
            <p>
              İçeriğinizin sahibi siz olarak kalırsınız. Hizmet içinde göstermek,
              denetlemek ve teknik olarak işlemek için Tripzy’ye gerekli sınırlı
              kullanım iznini vermiş olursunuz.
            </p>
          </section>

          <section>
            <h2>4. Premium abonelik ve otomatik yenileme</h2>
            <ul>
              <li>Güncel fiyat ve dönem bilgisi satın alma anında Google Play’de gösterilir.</li>
              <li>Abonelik, Google Play hesabınızın ayarlarına göre otomatik yenilenebilir.</li>
              <li>İptal işlemi Google Play abonelik yönetimi üzerinden yapılır.</li>
              <li>Uygulamayı kaldırmak veya Tripzy hesabını silmek aboneliği tek başına iptal etmez.</li>
              <li>İade ve ödeme uyuşmazlıkları Google Play kurallarına tabidir.</li>
            </ul>
          </section>

          <section>
            <h2>5. AI planları ve öneriler</h2>
            <p>
              Yapay zekâ tarafından oluşturulan planlar öneri niteliğindedir.
              İşletme saatleri, fiyatlar, erişilebilirlik, hava durumu, yerel
              koşullar ve ulaşım seçenekleri değişebilir. Seyahatten önce önemli
              bilgileri resmî veya güncel kaynaklardan doğrulamak kullanıcının
              sorumluluğundadır.
            </p>
          </section>

          <section>
            <h2>6. Rota ve güvenlik bilgileri</h2>
            <p>
              Rota, süre ve mesafe değerleri harita ve rota sağlayıcılarından
              gelen tahminlerdir. Yol kapanması, trafik, toplu taşıma değişikliği
              veya konum doğruluğu nedeniyle farklılık olabilir. Tripzy bir acil
              durum navigasyon hizmeti değildir. Acil durumlarda yerel yetkili
              kurumların talimatlarını izleyin.
            </p>
          </section>

          <section>
            <h2>7. Yasaklanan kullanım</h2>
            <ul>
              <li>Hizmete izinsiz erişmeye, güvenlik önlemlerini aşmaya veya sistemi bozmaya çalışmak.</li>
              <li>Otomatik araçlarla aşırı istek göndermek, spam veya sahte hesap oluşturmak.</li>
              <li>Hizmeti yasa dışı, zararlı veya üçüncü taraf haklarını ihlal eden amaçlarla kullanmak.</li>
              <li>Tripzy verilerini izinsiz toplamak, çoğaltmak veya ticari olarak yeniden sunmak.</li>
            </ul>
            <p>
              Bu kuralların ihlalinde içerik kaldırılabilir, özellik erişimi
              kısıtlanabilir veya hesap kapatılabilir.
            </p>
          </section>

          <section>
            <h2>8. Hizmetin kullanılabilirliği</h2>
            <p>
              Hizmetin kesintisiz veya hatasız olacağı garanti edilmez. Bakım,
              güvenlik, sağlayıcı değişiklikleri veya teknik nedenlerle özellikler
              geçici olarak durdurulabilir ya da güncellenebilir. Makul güvenlik
              ve süreklilik önlemleri uygulanır.
            </p>
          </section>

          <section>
            <h2>9. Gizlilik, hesap silme ve iletişim</h2>
            <p>
              Veri işleme ayrıntıları için <Link to="/privacy">Gizlilik Politikası</Link>,
              hesabınızı kapatmak için <Link to="/delete-account">Hesap ve Veri
              Silme</Link>, sorularınız için <Link to="/contact">İletişim</Link>{' '}
              sayfasını kullanabilirsiniz.
            </p>
          </section>

          <section>
            <h2>10. Koşullardaki değişiklikler</h2>
            <p>
              Hizmet ve yasal gereklilikler değiştikçe bu koşullar güncellenebilir.
              Önemli değişiklikler uygun kanallardan duyurulur. Güncelleme
              sonrasında hizmeti kullanmaya devam etmeniz yeni koşullara tabi
              olabilir.
            </p>
          </section>
        </article>
      </div>
    </section>
  );
}
